import womensHealthFeatures from '@/app/[locale]/womens-health/_data/womensHealthFeatures';
import womensHealthFeaturesGradients from '@/app/[locale]/womens-health/_data/womensHealthFeaturesGradients';
import LandingPageFeatures from '@/app/components/LandingPage/LandingPageFeatures';

const WomensHealthFeatures = () => {
  return (
    <LandingPageFeatures
      data-cy="womens-health-features"
      eyebrow="explore_features"
      features={womensHealthFeatures}
      imageGradientBg={{
        className: 'bg-olive-500',
        gradients: womensHealthFeaturesGradients,
      }}
      textColor="olive-800"
    />
  );
};
export default WomensHealthFeatures;
